import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-common/fulfillment-group-status";
import DotIcon from "@redotech/redo-icons/dot-01.svg";
import {
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeSize,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const statusBadgeText = {
  [FulfillmentGroupStatus.Open]: "Open",
  [FulfillmentGroupStatus.Closed]: "Closed",
  [FulfillmentGroupStatus.Cancelled]: "Cancelled",
  [FulfillmentGroupStatus.Pending]: "Pending",
  [FulfillmentGroupStatus.OnHold]: "On Hold",
  [FulfillmentGroupStatus.Scheduled]: "Scheduled",
  [FulfillmentGroupStatus.Incomplete]: "Incomplete",
  [FulfillmentGroupStatus.Voided]: "Voided",
  [FulfillmentGroupStatus.PaymentPending]: "Payment Pending",
  [FulfillmentGroupStatus.ReadyForPickup]: "Ready for Pickup",
  [FulfillmentGroupStatus.ThirdPartyInProgress]: "Third-Party In Progress",
  [FulfillmentGroupStatus.OpenNotReceived]: "Open - Not Received",
  [FulfillmentGroupStatus.Merged]: "Merged", // this should never be seen in the UI
  [FulfillmentGroupStatus.Unmerged]: "Unmerged", // this should never be seen in the UI
  [FulfillmentGroupStatus.Invalid]: "Invalid", // this should never be seen in the UI
  [FulfillmentGroupStatus.Deleted]: "Deleted", // this should never be seen in the UI
};
const statusBadgeColor: Record<FulfillmentGroupStatus, RedoBadgeColor> = {
  [FulfillmentGroupStatus.Open]: "success",
  [FulfillmentGroupStatus.Closed]: "blue",
  [FulfillmentGroupStatus.Cancelled]: "error",
  [FulfillmentGroupStatus.Pending]: "warning",
  [FulfillmentGroupStatus.OnHold]: "warning",
  [FulfillmentGroupStatus.Scheduled]: "success",
  [FulfillmentGroupStatus.Incomplete]: "warning",
  [FulfillmentGroupStatus.Voided]: "error",
  [FulfillmentGroupStatus.PaymentPending]: "warning",
  [FulfillmentGroupStatus.ReadyForPickup]: "blueLight",
  [FulfillmentGroupStatus.ThirdPartyInProgress]: "warning",
  [FulfillmentGroupStatus.OpenNotReceived]: "warning",
  [FulfillmentGroupStatus.Merged]: "blue", // this should never be seen in the UI
  [FulfillmentGroupStatus.Unmerged]: "orange", // this should never be seen in the UI
  [FulfillmentGroupStatus.Invalid]: "blue", // this should never be seen in the UI
  [FulfillmentGroupStatus.Deleted]: "error", // this should never be seen in the UI
};

export const FulfillmentGroupStatusBadge = memo(
  function FulfillmentGroupStatusBadge({
    fulfillmentGroupStatus,
    size = "xs",
  }: {
    fulfillmentGroupStatus: FulfillmentGroupStatus | null | undefined;
    size?: RedoBadgeSize;
  }) {
    return (
      <Flex flexDirection="column" justify="center">
        <RedoBadge
          color={
            statusBadgeColor[
              fulfillmentGroupStatus || FulfillmentGroupStatus.Open
            ]
          }
          segmentLeading={{ type: "icon", Icon: DotIcon }}
          size={size}
          text={
            statusBadgeText[
              fulfillmentGroupStatus || FulfillmentGroupStatus.Open
            ]
          }
          type="primary"
        />
      </Flex>
    );
  },
);
